import(/* webpackMode: "eager", webpackExports: ["HomeHeader","HomeFooter"] */ "/vercel/path0/apps/landing/src/components/home/figma-homepage.tsx");
